"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next13_utils_common_to_kebap_case_1 = __importDefault(require("@gerenciatd/next13.utils.common.to-kebap-case"));
const next13_utils_common_normalize_string_1 = __importDefault(require("@gerenciatd/next13.utils.common.normalize-string"));
const transformObjectKeysToGaFormat = (object) => {
    let result = {};
    const keys = object ? Object.keys(object) : [];
    keys.forEach(keyName => {
        let newKey = (0, next13_utils_common_to_kebap_case_1.default)(keyName);
        newKey = (0, next13_utils_common_normalize_string_1.default)(newKey);
        const value = object[keyName];
        result[newKey] = value;
    });
    return result;
};
exports.default = transformObjectKeysToGaFormat;
//# sourceMappingURL=index.js.map